const getters = {
    userInfo: state => state.user.userInfo,
    imInfo: state => state.user.imInfo,
    orderDetail: state => state.user.orderDetail,
    step: state => state.global.step,
    userID: state => state.user.userID,
    hasMask: state => state.global.hasMask,
    urlParams: state => state.global.urlParams,
    doctorInfo: state => state.global.doctorInfo,
    sourcePath: state => state.global.sourcePath,
    deviceType: state => state.global.deviceType,
    endInquiry: state => state.global.endInquiry,
    timDuration: state => state.global.timDuration,
    huafuUI: state => state.global.huafuUI,
    theme: state => state.global.theme,
}
export default getters
